import TimeConstants from 'owa-datetime-utils/lib/TimeConstants';
import { addDays, OwaDate } from 'owa-datetime';
import { ColumnProvider, DatesColumnProvider } from 'owa-calendar-surface-dategrid';
import type { DateRange } from 'owa-datetime-utils';
import { DateRangeType } from '@fluentui/date-time-utilities/lib/dateValues/dateValues';

/** Creates a layout manager for a 7-day week starting in the specified date. */
export function getWeekLayout(
    store: {
        dateRange: DateRange;
        dayStartMinute: number;
        dayLength: number;
    },
    firstDayOfWeek: OwaDate
): ColumnProvider {
    return new DatesColumnProvider({
        dateRange: {
            start: firstDayOfWeek,
            end: addDays(firstDayOfWeek, TimeConstants.DaysInOneWeek - 1),
        },
        dateRangeType: DateRangeType.Week,
        userOptions: {
            workDays: null,
        },
        dayStartMinute: store.dayStartMinute,
        dayLength: store.dayLength,
        weekViewPixelsPerMinuteRatio: 1, // for week view layout, no scaling
    });
}
